import React from 'react';
import { useNavigate } from 'react-router-dom';

const VECIAccessDenied = ({ message }) => {
  const navigate = useNavigate();
  return (
    <div className='card border-0 shadow-sm rounded-4 p-5 text-center bg-white'>
      <div className='bg-danger bg-opacity-10 p-4 rounded-circle d-inline-block mb-4 mx-auto'>
        <i className='bi bi-shield-lock text-danger display-4'></i>
      </div>
      <h3 className='fw-bold text-dark mb-3'>Akses Dibatasi</h3>
      <p
        className='text-muted mx-auto'
        style={{ maxWidth: '500px' }}
      >
        {message ||
          `Maaf, akses ditutup. Pengisian survei daya saing (VECI) ini hanya
          diizinkan untuk petugas (PO) yang telah ditugaskan secara resmi oleh
          pusat untuk menangani BUMDes ini. Satu BUMDes hanya boleh diisi oleh
          satu petugas yang ditunjuk.`}
      </p>
      <hr
        className='my-4 mx-auto'
        style={{ width: '50px' }}
      />
      <p className='small text-muted'>
        Silakan hubungi Admin atau Koordinator Wilayah jika Anda merasa
        seharusnya memiliki akses ke formulir ini.
      </p>
      <button
        type='button'
        className='btn btn-outline-secondary mt-3 rounded-pill px-4'
        onClick={() => navigate('/program')}
      >
        Kembali ke Daftar
      </button>
    </div>
  );
};

export default VECIAccessDenied;
